module.exports = __webpack_public_path__ + "img/adult-icon.fe8b3294.svg";